import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import VagasTable from './components/VagasTable';

import { Container, Fab, Grid, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { getOpportunityCompany } from '../../serviceAPI/opportunity/getOpportunityCompany'
import history from '../../history';


const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(3),
    },
    addButton: {
        position: "fixed",
        zIndex: 1000,
        bottom: theme.spacing(4),
        right: theme.spacing(4),
    }
}));

function GerenciarVagas() {
    const classes = useStyles();
    const vagas = useSelector(state => state.opportunity.opportunities)
    const dispatch = useDispatch();

    React.useEffect(() => {
        getOpportunityCompany(dispatch);
    }, []);

    function openCreateOpportunity() {
        history.push(`cadastrar-vagas`);
    }

    function openEditOpportunity(vagaSelecionada) {
        history.push(`editar-vaga`, vagaSelecionada);
    }

    return (
        <>
            <Container>
                <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                >
                    <div className={classes.addButton}>
                        <Tooltip title="Nova vaga">
                            <Fab color="primary" aria-label="add" onClick={() => openCreateOpportunity()}>
                                <AddIcon />
                            </Fab>
                        </Tooltip>
                    </div>

                </Grid>
                <div className={classes.container}>
                    <VagasTable vagas={vagas} openEdit={openEditOpportunity} />
                </div>
            </Container>
        </>
    )
}

export default GerenciarVagas;